import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const initialState:any = {};

const supportedAssetsSlice = createSlice({
  name: 'supportedAssets',
  initialState,
  reducers: {
    setSupportedAssets(state,action:PayloadAction<any>){
      state.supportedAssets = action.payload;
    }
  },

});

// Reducer
export default supportedAssetsSlice.reducer;

// Actions
export const {setSupportedAssets} = supportedAssetsSlice.actions;

